import React from "react";
import { AutoComplete, Col, Form, Input, Modal, Row, theme } from "antd";
import ErrorMessages from "../../common/ErrorMessages";
import useDropdownItem from "../../common/useDropdownItem";
import { URL_EMPLOYEE, URL_USER } from "../../constants/urls";
import { PATCH, POST } from "../../frameworks/HttpClient";
import _ from "lodash";
import { USER_GROUP } from "../../constants/string";
import { useUserContext } from "../../hooks/UserSettingProvider";

export default function EmployeeModal(props) {
  const { target, open, onClose, onUpdate } = props;
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [loading, setLoading] = React.useState(null);
  const [form] = Form.useForm();
  const isCreate = target === 'add'
  const [debouncedUser, setDebouncedUser] = React.useState('');
  const { features } = useUserContext();
  const tankLotDisplayMethod = _.get(features, 'tank_lot_display_method', false)
  const debounceUser = React.useCallback(_.debounce((_searchVal) => { setDebouncedUser(_searchVal) }, 800), []);
  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const filterLabGroup = tankLotDisplayMethod === 'inter_rubber' ? USER_GROUP.QC : USER_GROUP.LAB

  const userDropdown = useDropdownItem({ 
    manual : true, 
    url: `${URL_USER.USER}`, 
    label: 'first_name',
    value:'first_name', 
    pagination: true, 
    params: { page_size: 999, full_name: debouncedUser, groups : filterLabGroup }
  })

  const handleSave = async() => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      if(isCreate){
        await POST(URL_EMPLOYEE.EMPLOYEE, data)
        onUpdate();
      } else {
        await PATCH(`${URL_EMPLOYEE.EMPLOYEE}${target.id}/`, data)
        onUpdate();
      }
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if(open){
      form.setFieldsValue(target);
    } else {
      form.resetFields();
    }
  },[open])

  React.useEffect(() => {
    if(open){
      userDropdown.fetchOptions();
    }
  },[debouncedUser])

  return(
    <Modal
      open={open}
      title={isCreate ? "สร้าง Pin พนักงาน" : "แก้ไข Pin พนักงาน"}
      onCancel={onClose}
      onOk={handleSave}
      okText={"เพิ่ม"}
      cancelText={"ปิด"}
      okButtonProps={{ style: { backgroundColor : isCreate ? colorSuccess : colorWarning}, loading : loading }}
    >
      <ErrorMessages message={errorMessages}/>
      <Form
					form={form}
          layout="vertical">
          <Row>
            <Col span={24}>
              <Form.Item 
                label={'พนักงาน LAB'} 
                name={"name"}
                rules={[{ required : true, message: 'กรุณากรอกข้อมูล' }]}
              >
                <AutoComplete 
                  style={{ width : '100%' }} 
                  placeholder={'พนักงาน LAB'} 
                  autoComplete="off" 
                  options={userDropdown.options} 
                  onSearch={debounceUser}
                  onSelect={(value, option) => form.setFieldValue('code', option.username )}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item 
                label={'Code'}
                name={"code"}
                style={{marginRight : 10}}
                rules={[{ required : true, message: 'กรุณากรอกข้อมูล' }]}
              >
                <Input style={{ width : '100%' }} placeholder={'Code'} autoComplete="off"/>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item 
                label={'Pin'} 
                name={"pin"}
                rules={[{ required : true, message: 'กรุณากรอกข้อมูล' }]}
              >
                <Input style={{ width : '100%' }} placeholder={'Pin'} autoComplete="off"/>
              </Form.Item>
          </Col>
          </Row>
        </Form>
    </Modal>
  )
}